export default "__VITE_ASSET__DJ$6yc7$__"